import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebApiService } from './web-api.service';

@Injectable({
  providedIn: 'root'
})
export class ClubService {
  private apiUrl = 'Club';
  constructor(private http: WebApiService) {}

  getClubs(): Observable<any[]> {
    return this.http.get(this.apiUrl);
  }

  getVipUsers(clubId: number): Observable<any[]> {
    return this.http.get(`${this.apiUrl}/${clubId}/VipUsers`);
  }

  addVipUser(clubId: number, userId: number, note: string): Observable<boolean> {
    return this.http.put(`${this.apiUrl}/${clubId}/Vip/${userId}/${encodeURIComponent(note)}`, {});
  }

  removeVipUser(clubId: number, userId: number): Observable<boolean> {
    return this.http.delete(`${this.apiUrl}/${clubId}/Vip/${userId}`);
  }
}
